import { useEffect, useState } from "react";
import { Tag, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { Skeleton, EmptyState } from "@/components/common";
import { useT } from "@/context/i18n";

const catColor = { Cashback: "bg-emerald-50 text-emerald-700", Partner: "bg-blue-50 text-blue-700", "EMI Offer": "bg-purple-50 text-purple-700", Discount: "bg-amber-50 text-amber-700" };

export default function Offers() {
  const [offers, setOffers] = useState(null);
  const t = useT();
  useEffect(() => { api.get("/offers").then((r) => setOffers(r.data)).catch(() => setOffers([])); }, []);
  if (!offers) return <div className="grid gap-4 sm:grid-cols-2">{[1, 2, 3, 4].map((i) => <Skeleton key={i} className="h-44" />)}</div>;
  const groups = ["Cashback", "Partner", "Discount", "EMI Offer"];
  return (
    <div className="space-y-6">
      <div><h1 className="font-display text-2xl font-bold text-[#0B132B]">{t("Offers")}</h1><p className="text-sm text-slate-500">{t("Partner offers, cashback, coupons and special EMI deals.")}</p></div>
      {offers.length === 0 ? <EmptyState icon={Tag} mascot title={t("No offers right now")} desc={t("Check back soon — new partner offers are added regularly.")} /> : groups.map((g) => {
        const items = offers.filter((o) => o.category === g);
        if (!items.length) return null;
        return (
          <div key={g}>
            <h2 className="font-display text-lg font-bold text-[#0B132B]">{g === "Partner" ? t("Partner Offers") : g === "EMI Offer" ? t("Special EMI Offers") : g}</h2>
            <div className="mt-3 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {items.map((o) => (
                <div key={o.id} className="flex flex-col rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition hover:shadow-md">
                  <div className="flex items-center justify-between">
                    <span className={`rounded-md px-2 py-0.5 text-xs font-semibold ${catColor[o.category] || "bg-slate-100 text-slate-600"}`}>{o.category}</span>
                    <span className="text-xs text-slate-400">{o.partner}</span>
                  </div>
                  <p className="mt-3 font-display font-bold text-[#0B132B]">{o.title}</p>
                  <p className="mt-1 flex-1 text-sm text-slate-500">{o.description}</p>
                  <div className="mt-3 space-y-1 border-t border-slate-100 pt-3 text-xs text-slate-400">
                    <p>Eligibility: {o.eligibility}</p><p>Expires: {o.expiry}</p>
                  </div>
                  <button data-testid={`offer-${o.id}`} className="mt-3 inline-flex items-center justify-center gap-1.5 rounded-md border border-[#14B8A6] px-3 py-2 text-sm font-semibold text-[#14B8A6] hover:bg-emerald-50"><Sparkles size={14} /> {t("Claim Offer")}</button>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
